import { createSlice, createAction, PayloadAction } from "@reduxjs/toolkit";
import values from "lodash/values";
import get from "lodash/get";

// Trigger action for saga compatibility (saga watches this, not a slice reducer)
export const changePassword = createAction<any>("changePassword/trigger");

// External action this slice responds to
import { logoutStart } from "@/store/slices/auth";

interface ChangePasswordState {
  updating: boolean;
  failed: boolean;
  errors: string[];
  message?: string;
}

const initialState: ChangePasswordState = {
  updating: false,
  failed: false,
  errors: [],
};

const changePasswordSlice = createSlice({
  name: "changePassword",
  initialState,
  reducers: {
    changePasswordStart(state) {
      state.updating = true;
      state.failed = false;
      state.errors = [];
    },
    changePasswordSuccess(state) {
      state.updating = false;
      state.message = "Password changed!";
    },
    changePasswordFailure(state, action: PayloadAction<any>) {
      state.updating = false;
      state.failed = true;
      state.errors = values(
        get(action.payload, "response.data.errors", {
          standard: "Error updating the password!",
        })
      );
    },
    clearChangePasswordErrors(state) {
      state.errors = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutStart, () => ({ ...initialState }));
  },
});

export const {
  changePasswordStart,
  changePasswordSuccess,
  changePasswordFailure,
  clearChangePasswordErrors,
} = changePasswordSlice.actions;

export default changePasswordSlice.reducer;
